import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo2_Rodrigo } from '../../../../../utils/ES/Modals/directors';

const ModalVideoRodrigo2 = () => {
  return (
    <>
      <ModalVideo
        id="rodrigo-video-2"
        dataText={TextVideo2_Rodrigo}
        videoSrc="https://player.vimeo.com/video/380624538?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_RODRIGO_2"
      />
    </>
  );
};

export default ModalVideoRodrigo2;
